function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { loginObj, validateError } from '@/services/base';
import axios from 'axios';
import setupInterceptors from '@/services/setupInterceptors';
import tasks from '@/js/tasks';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
var appApisGTW = null;
if (!configuration['master_data']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':8090')
  });
} else {
  appApisGTW = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8091')
  });
}
setupInterceptors(appApisGTW);
var CONTROLLER_NAME = '/master_data';
var DOMAIN_BUSINESS_TERM = '/business_term';
export default {
  getBusinessTerms: function getBusinessTerms() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_BUSINESS_TERM, "/get_all"), body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (error) {
      tasks.lockScreen.unlock();
      console.error(error);
    });
  },
  getBusinessTerm: function getBusinessTerm() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_BUSINESS_TERM, "/get"), body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (error) {
      tasks.lockScreen.unlock();
      console.error(error);
    });
  },
  getSharedTerms: function getSharedTerms() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_BUSINESS_TERM, "/shared/get_all"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (error) {
      tasks.lockScreen.unlock();
      console.error(error);
    });
  },
  createBusinessTerm: function createBusinessTerm() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_BUSINESS_TERM), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (error) {
      tasks.lockScreen.unlock();
      console.error(error);
    });
  },
  updateBusinessTerm: function updateBusinessTerm() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.put("".concat(CONTROLLER_NAME).concat(DOMAIN_BUSINESS_TERM), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (error) {
      tasks.lockScreen.unlock();
      console.error(error);
    });
  },
  deleteBusinessTerm: function deleteBusinessTerm() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var params = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_BUSINESS_TERM) + '/delete_bterm', params).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (error) {
      tasks.lockScreen.unlock();
      console.error(error);
    });
  },
  manageTermDataCatalogTable: function manageTermDataCatalogTable() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_BUSINESS_TERM, "/data_catalog/manage"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (err) {
      var message = '(manageBussinesTermTable)';
      var response = validateError(err, message, function () {
        appApisGTW.manageBussinesTermTable(data);
      });
      // const response = validateError(err, message)
      return response;
    });
  },
  searchBusinessTerm: function searchBusinessTerm() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_BUSINESS_TERM, "/search_query"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (error) {
      tasks.lockScreen.unlock();
      console.error(error);
    });
  },
  businessTermQueryNew: function businessTermQueryNew(data) {
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_BUSINESS_TERM, "/businessTermQueryNew/"), body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      tasks.lockScreen.unlock();
      var message = '(businessTermQueryNew) Search driver connection';
      var response = validateError(err, message, function () {
        appApisGTW.businessTermQueryNew(data);
      });
      return response;
    });
  },
  businessTermQueryNewAllDomain: function businessTermQueryNewAllDomain(data) {
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_BUSINESS_TERM, "/businessTermQueryNewAllDomain/"), body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      tasks.lockScreen.unlock();
      var message = '(businessTermQueryNewAllDomain) Search driver connection';
      var response = validateError(err, message, function () {
        appApisGTW.businessTermQueryNewAllDomain(data);
      });
      return response;
    });
  },
  businessTermLogQuery: function businessTermLogQuery() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_BUSINESS_TERM, "/log_query"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (error) {
      tasks.lockScreen.unlock();
      console.error(error);
    });
  },
  bulkLoad: function bulkLoad() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_BUSINESS_TERM, "/bulk_load"), body).then(function (response) {
      return response.data;
    }).finally(function () {
      tasks.lockScreen.unlock();
    });
  }
};